export enum StoreCategoryEnum {
  Retailer = "Retailer",
  Wholesaler = "Wholesaler",
  Distributor = "Distributor",
  Manufacturer = "Manufacturer",
  ServiceProvider = "ServiceProvider",
  Hospitality = "Hospitality", // For hotels, restaurants, etc.
  PersonalCare = "PersonalCare", // For hair salons, spas, etc.
}
